import { NgModule } from '@angular/core';
import { SSE_GATEWAY } from '@prlw/core/sse/sse.gateway';
import { SseGateway } from './sse.gateway';

@NgModule({
  providers: [{ provide: SSE_GATEWAY, useClass: SseGateway }],
})
export class SseDataModule {}
